function LabeledInput(props: {
    id: string;
    label: string;
    placeholder: string;
    required?: boolean;
    type?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    defaultValue?: string;
    disabled?: boolean;
    extra?: string;
}) {
    const {
        id,
        label,
        placeholder,
        required,
        type = 'text',
        onChange,
        value,
        defaultValue,
        disabled,
        extra,
    } = props;

    return (
        <fieldset
            className={`rounded-xl border bg-white px-3 transition-colors focus-within:border-leadrs-yellow-focus ${
                disabled
                    ? 'border-leadrs-disabled-stroke bg-leadrs-disabled'
                    : 'border-leadrs-stroke'
            } ${extra ?? ''}`}
        >
            <legend className="ml-2 px-1 font-geist text-xs text-leadrs-text-soft">
                {label}
                {required && (
                    <span className="ml-0.5 text-leadrs-wrong">*</span>
                )}
            </legend>
            <input
                id={id}
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                defaultValue={defaultValue}
                disabled={disabled}
                className="w-full pb-2.5 font-geist text-sm font-medium text-leadrs-text outline-none placeholder:font-normal placeholder:text-leadrs-text-soft/50 disabled:cursor-not-allowed"
            />
        </fieldset>
    );
}

export default LabeledInput;
